<template>
  <ul v-if="errors && errors.length > 0" class="validation-errors">
    <li
      class="error"
      v-for="item in errors"
      v-bind:key="item"
    >{{item}}</li>
  </ul>
</template>

<script>
export default {
  name: "ValidationField",
  props: {
    errors: Array
  }
};
</script>